import { render, staticRenderFns } from "./UtilityDetail.vue?vue&type=template&id=78c58f5c"
import script from "./UtilityDetail.vue?vue&type=script&lang=js"
export * from "./UtilityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports